export default __webpack_public_path__ + "static/media/emptyBetslip.93d07b18.png";